import React from 'react'
import PropTypes from 'prop-types'
import useScreen from '../../hooks/useScreen'

export const ToolTip = ({
    text,
    position = 'bottom',
    translate = 'translate(95%, -420%)',
}) => {
    if (!text) return null
    const { isMobile, isTablet } = useScreen()

    return (
        <>
            {position === 'bottom' && (
                <div
                    className="absolute top-6 flex flex-col items-center mt-6 w-full z-[9999] pointer-events-none"
                    style={{
                        position: 'absolute',
                    }}
                >
                    <div className="w-3 h-3 transform rotate-45 bg-black50"></div>
                    <span
                        className="relative inline-block -mt-2 z-[9999] p-2 leading-none text-white font-normal whitespace-normal bg-black50 shadow-lg rounded-lg text-center text-xs"
                        style={{
                            maxWidth: '100%',
                            minWidth: '90px',
                        }}
                    >
                        {text}
                    </span>
                </div>
            )}

            {position === 'top' && (
                <div
                    className="absolute bottom-8 flex flex-col items-center mb-5 w-full z-[9999] pointer-events-none"
                    style={{
                        position: 'absolute',
                    }}
                >
                    <span
                        className="relative inline-block -mb-2 z-[9999] p-2 leading-none text-white font-normal whitespace-normal bg-black50 shadow-lg rounded-lg text-center text-xs"
                        style={{
                            maxWidth: '100%',
                            minWidth: '90px',
                        }}
                    >
                        {text}
                    </span>
                    <div className="w-3 h-3 transform rotate-45 bg-black50"></div>
                </div>
            )}

            {position === 'left' && (
                <div
                    className="absolute flex items-center z-[9999] pointer-events-none"
                    style={{
                        top: '50%',
                        transform: 'translate(-105%, -50%)',
                    }}
                >
                    <div
                        className="w-3 h-3 transform rotate-45 bg-black50"
                        style={{
                            position: 'absolute',
                            right: '-3px',
                        }}
                    ></div>
                    <span
                        className="relative inline-block z-[9999] p-2 leading-none text-white font-normal whitespace-normal bg-black50 shadow-lg rounded-lg text-center text-xs"
                        style={{
                            width: '145px',
                            marginLeft: '10px',
                        }}
                    >
                        {text}
                    </span>
                </div>
            )}

            {position === 'right' && (
                <div
                    className="absolute flex items-center z-[9999] pointer-events-none"
                    style={{
                        top: '50%',
                        transform:
                            isMobile || isTablet
                                ? translate
                                : 'translate(80%, -50%)',
                    }}
                >
                    <div
                        className="w-3 h-3 transform rotate-45 bg-black50"
                        style={{
                            position: 'absolute',
                            left: '-3px',
                        }}
                    ></div>
                    <span
                        className="relative inline-block z-[9999] p-2 leading-none text-white font-normal whitespace-normal bg-black50 shadow-lg rounded-lg text-center text-xs"
                        style={{
                            width: '145px',
                            marginRight: '10px',
                        }}
                    >
                        {text}
                    </span>
                </div>
            )}
        </>
    )
}

ToolTip.propTypes = {
    text: PropTypes.string.isRequired,
    position: PropTypes.oneOf(['bottom', 'top', 'left', 'right']),
    translate: PropTypes.string,
}

export default ToolTip
